import axios from "axios";

export default async function fetchCommitteeAgendas(
  legislatureOrdinal,
  committeeType,
  committeeTypeCode,
  committeeCode,
  chamber,
  meetingDateTime
) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getMeetingAgendas`,
      {
        params: {
          legislatureOrdinal,
          committeeType,
          committeeTypeCode,
          committeeCode,
          chamber,
          meetingDateTime
        },
      }
    );
    if (!Array.isArray(response.data) || response.data.length === 0) {
      return [];
    }

    // Just return the documents with their IDs, don't fetch URLs yet
    return response.data;

  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching committee Agendas:", error);
    }
    return [];
  }
}
